import { getCampaign, getCharity } from '../../selectors/apiSelectors';

import CauseCard from '../../components/CauseCard/CauseCard';
import { IAppState } from '../../types/state.d';
import config from '../../config';
import { connect } from 'react-redux';

type CauseCardContainerOwnProps = {
  className?: string;
};

export const mapStateToProps = (
  state: IAppState,
  ownProps: CauseCardContainerOwnProps,
) => {
  const campaign = getCampaign(state);
  const title = campaign.title;
  const { name, logo } = getCharity(state);

  return {
    name: title || name || '',
    // If the cause comes from ES, the logo is a full URL. If the cause comes from the AWS APIs, the URL is only the image guid
    logo: logo?.match(/images.*.justgiving.com/)
      ? logo
      : `${config.imageAPIBaseURL}/${logo}`,
    parentName: title ? name : '',
    className: ownProps.className || '',
  };
};

export default connect(mapStateToProps)(CauseCard);
